(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ResetFinish1Controller', ResetFinish1Controller);

    ResetFinish1Controller.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService','ChangeEmail'];

    function ResetFinish1Controller ($stateParams, $timeout, Auth, LoginService,ChangeEmail) {
        var vm = this;

        vm.keyMissing = $stateParams.key;
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        changeEmail();
        
        function changeEmail() {
        	
        	console.log(vm.keyMissing);
        	ChangeEmail.updateForCustomer({"key" : vm.keyMissing}, onSaveSuccess, onSaveError);
        }
        
        function onSaveSuccess(result) {
        	 if (result.hasOwnProperty('IsPendingEmailChangeDiscarded') && result.IsPendingEmailChangeDiscarded != null && result.IsPendingEmailChangeDiscarded == true) {
        		 vm.IsPendingEmailChangeAlreadyDiscarded = true;
        	 }else{
        		 vm.IsPendingEmailChangeAlreadyDiscarded = false;
        	 }
        	 console.log(vm.IsPendingEmailChangeAlreadyDiscarded);
		}

		function onSaveError() {

			//$scope.clicked = false;
		}
		
        
        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
